import { ProductionRecordFieldEnum as ProdRecordFields } from 'Common/FieldEnum';
import { ProductionStatusEnum } from 'Common/Constants/Enumeration/ProductionStatusEnum';
import * as types from './types';

const INITIAL_STATE = Object.freeze({
  menus: [],
  prodRecords: [],
  fetchingMenus: false,
  fetchingProdRecords: false,
  fetchingCloseProdRecord: false,
  error: null,
  closeProdRecordSuccessful: false,
});

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.MANAGE_PRODUCTION_FETCHING_MENUS:
      return { ...state, fetchingMenus: payload };

    case types.MANAGE_PRODUCTION_FETCHING_PRODUCTION_RECORDS:
      return { ...state, fetchingProdRecords: payload };

    case types.MANAGE_PRODUCTION_SET_MENUS:
      return { ...state, menus: payload };

    case types.MANAGE_PRODUCTION_SET_PRODUCTION_RECORDS:
      return { ...state, prodRecords: payload };

    case types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS:
      return {
        ...state,
        prodRecords: state.prodRecords.map(pr =>
          pr.Id === payload.Id
            ? {
                ...pr,
                [ProdRecordFields.IsClosed]: true,
                [ProdRecordFields.Status]: ProductionStatusEnum.Closed,
                [ProdRecordFields.CloserUserId]:
                  payload[ProdRecordFields.CloserUserId],
              }
            : pr
        ),
      };

    case types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_SUCCESS:
      return {
        ...state,
        prodRecords: state.prodRecords.map(pr =>
          pr.Id === payload.Id
            ? {
                ...pr,
                [ProdRecordFields.IsClosed]: false,
                [ProdRecordFields.Status]: ProductionStatusEnum.Open,
                [ProdRecordFields.CloserUserId]: "",
              }
            : pr
        ),
      };

    case types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING:
      return { ...state, fetchingCloseProdRecord: payload };

    case types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_LOADING:
      return { ...state, fetchingReopenProdRecord: payload };
  
    case types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR:
    case types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_ERROR:
    case types.MANAGE_PRODUCTION_SET_ERROR:
      return { ...state, error: payload };

    case types.MANAGE_PRODUCTION_CLEAR_ERROR:
      return { ...state, error: null };

    case types.MANAGE_PRODUCTION_CLEAR_STATE:
      return INITIAL_STATE;

    case types.MANAGE_PRODUCTION_SET_CLOSE_PRODUCTION_SUCCESSFUL:
      return { ...state, closeProdRecordSuccessful: payload };

    case types.MANAGE_PRODUCTION_SET_REOPEN_PRODUCTION_SUCCESSFUL:
      return { ...state, reopenProdRecordSuccessful: payload };
  
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/manageproduction/reducer.js